import { render, staticRenderFns } from "./forSign.vue?vue&type=template&id=6cf33b90&scoped=true"
import script from "./forSign.vue?vue&type=script&lang=js"
export * from "./forSign.vue?vue&type=script&lang=js"
import style0 from "./forSign.vue?vue&type=style&index=0&id=6cf33b90&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf33b90",
  null
  
)

export default component.exports